import React from 'react'
import Blockies from 'react-blockies'
import './Owner.scss'

interface IProps {
  address: string
}

export function Owner({ address }: IProps) {
  return (
    <>
      <Blockies size={5} seed={address} className="owner-avatar" />
      <a
        href={`https://etherscan.io/address/${address}`}
        target="_blank"
        rel="noopener noreferrer"
        className="owner-address"
      >
        {address}
      </a>
    </>
  )
}
